import React from "react";
import "./Certificates.css";

const certificatesData = [
  {
    id: 1,
    title: "Participation Certificate",
    image: "participation-certificate.png",
    aim: "Recognize active involvement",
    description:
      "Awarded to students who actively participated in our workshops, events, or training sessions. It acknowledges their enthusiasm and commitment to learning.",
  },
  {
    id: 2,
    title: "Experience Certificate",
    image: "experience-certificate.png",
    aim: "Highlight practical exposure",
    description:
      "Granted to individuals who completed internships or real-world projects with us, showcasing their hands-on industry exposure.",
  },
  {
    id: 3,
    title: "Course Completion Certificate",
    image: "course-completion-certificate.png",
    aim: "Validate knowledge acquisition",
    description:
      "Proof of successfully completing one of our structured courses. It demonstrates dedication, discipline, and mastery of the subject matter.",
  },
  {
    id: 4,
    title: "Best Project Award Certificate",
    image: "best-project-award-certificate.png",
    aim: "Encourage innovation",
    description:
      "Awarded to teams or individuals who delivered the most impactful project during their course or internship, motivating innovation and creativity.",
  },
  {
    id: 5,
    title: "Best Performance Certificate",
    image: "best-performance-centificate.png",
    aim: "Reward outstanding achievers",
    description:
      "Given to students who consistently excelled in assignments, exams, or practical challenges. It highlights dedication and consistent excellence.",
  },
  {
    id: 6,
    title: "Best Project Award (Advanced)",
    image: "best-project-award-certificate-advanced.png",
    aim: "Promote advanced research",
    description:
      "Special recognition for advanced-level projects that stand out in terms of innovation, technical depth, and societal impact.",
  },
];

const Certificates = () => {
  return (
    <div className="certificates-page">
      <h1 className="certificates-heading">Our Certificates</h1>
      <p className="certificates-subheading">
        Each certificate we provide is more than just a paper – it’s a symbol of skill, dedication, and growth.
      </p>
      <div className="certificates-grid">
        {certificatesData.map((cert) => (
          <div className="certificate-card" key={cert.id}>
            <img src={cert.image} alt={cert.title} className="certificate-img" />
            <div className="certificate-content">
              <h2 className="certificate-title">{cert.title}</h2>
              <h4 className="certificate-aim">🎯 {cert.aim}</h4>
              <p className="certificate-desc">{cert.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Certificates;
